(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["selvvo-lp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__slpAddBound) return;
    window.__slpAddBound = true;
    function setQty(q) {
      if (window.SelvvoBundle) {
        window.SelvvoBundle.select(q);
        return;
      }
      document.querySelectorAll('product-form-component input[name="quantity"]').forEach(function (i) {
        i.value = q;
        i.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    function add(q) {
      setQty(q);
      var btn = document.querySelector('product-form-component button[name="add"]');
      if (btn && !btn.disabled) {
        setTimeout(function () { btn.click(); }, 60);
        return;
      }
      var id = document.querySelector('product-form-component input[name="id"], form[action*="/cart/add"] [name="id"]');
      if (!id) return;
      var f = document.createElement('form');
      f.method = 'post';
      f.action = '/cart/add';
      f.innerHTML = '<input type="hidden" name="id" value="' + id.value + '"><input type="hidden" name="quantity" value="' + q + '">';
      document.body.appendChild(f);
      f.submit();
    }
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-slp-add]');
      if (a) {
        e.preventDefault();
        add(a.getAttribute('data-slp-add'));
        return;
      }
      var s = e.target.closest('[data-slp-scroll]');
      if (s) {
        e.preventDefault();
        var t = document.querySelector('[data-slp-bundle]') || document.querySelector('product-form-component');
        if (t) t.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["selvvo-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__slpAddBound) return;
    window.__slpAddBound = true;
    function setQty(q) {
      if (window.SelvvoBundle) {
        window.SelvvoBundle.select(q);
        return;
      }
      document.querySelectorAll('product-form-component input[name="quantity"]').forEach(function (i) {
        i.value = q;
        i.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    function add(q) {
      setQty(q);
      var btn = document.querySelector('product-form-component button[name="add"]');
      if (btn && !btn.disabled) {
        setTimeout(function () { btn.click(); }, 60);
        return;
      }
      var id = document.querySelector('product-form-component input[name="id"], form[action*="/cart/add"] [name="id"]');
      if (!id) return;
      var f = document.createElement('form');
      f.method = 'post';
      f.action = '/cart/add';
      f.innerHTML = '<input type="hidden" name="id" value="' + id.value + '"><input type="hidden" name="quantity" value="' + q + '">';
      document.body.appendChild(f);
      f.submit();
    }
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-slp-add]');
      if (a) {
        e.preventDefault();
        add(a.getAttribute('data-slp-add'));
        return;
      }
      var s = e.target.closest('[data-slp-scroll]');
      if (s) {
        e.preventDefault();
        var t = document.querySelector('[data-slp-bundle]') || document.querySelector('product-form-component');
        if (t) t.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
